// extracted by mini-css-extract-plugin
export default {"tablet":"(min-width: 768px)","anzac":"#e5a348","black":"#000000","white":"#ffffff","title":"R","title-bold":"S","titleBold":"S","version":"T","wrapper":"U"};